import Emails from './Emails';
import useEmailSuggestion from './useEmailSuggestion';

type Props = {
  handleSelectedSuggestionEmail: (selectedEmail: string) => void;
};

const EmailSuggestion = ({ handleSelectedSuggestionEmail }: Props) => {
  const selectedEmails = useEmailSuggestion();

  if (!selectedEmails) {
    return null;
  }

  return (
    <div className="flex items-center justify-start gap-2 text-moon-14 text-bulma">
      {selectedEmails.map((selectedEmail) => (
        <Emails
          key={selectedEmail}
          email={selectedEmail}
          handleSelectedSuggestionEmail={handleSelectedSuggestionEmail}
        />
      ))}
    </div>
  );
};

export default EmailSuggestion;
